<template>
  <div class="text-gray-500 text-center mx-auto w-3/4 max-w-[350px]">
    <div class="flex justify-center my-4">
      <PermissionStatusCircle icon="icon-map-pin" ready></PermissionStatusCircle>
    </div>
    <div class="font-bold text-lg text-gray-700">Location Services</div>
    <p class="my-6">
      Your device's location is used to <span class="text-gray-700 font-medium">quickly</span> lookup
      <span class="text-gray-700 font-medium">nearby equipment</span> and properties. It is also used to save the GPS
      coordinates of equipment you install for future technicians to
      <span class="text-gray-700 font-medium">easily</span> find.
    </p>
    <div v-if="locationPermission.ready">
      <div class="text-lg font-bold text-gray-700">Good to go!</div>
      <p>
        NCSS has the necessary access to Location Services<br /><span class="text-gray-700 font-bold">Thank you</span>
      </p>
    </div>
    <PermissionDialog v-else>Allow "NCSS" to use your location?</PermissionDialog>
  </div>
</template>

<script setup lang="ts">
import PermissionStatusCircle from '@/components/permissions/PermissionStatusCircle.vue';
import PermissionDialog from './PermissionDialog.vue';
import { useLocationPermission } from '@/stores/permissions/location-permission.store';

const locationPermission = useLocationPermission();
</script>

<style scoped></style>
